// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Dtkh","gfeWrapper":"CalendarEvent_gfeWrapper__GRHa1"};